import { DomainNode, NodeDTOTypes } from '@store/services/nodes/types';
import { IDomain } from '@store/services/projects/types';

export const SCOPE_FILTER_NO_OPERATIONALISED = '__no_operationalised_scope__';
export const SCOPE_FILTER_UNASSIGNED = '__unassigned_scope__';

export const isSpecialScopeFilter = (id: string) =>
  id === SCOPE_FILTER_NO_OPERATIONALISED || id === SCOPE_FILTER_UNASSIGNED;

export const extractDomainFilterIds = (ids: string[]) =>
  ids.filter((id) => !isSpecialScopeFilter(id));

export const findWideDomain = (domains: IDomain[]) => {
  return domains.find(({ level, num }) => level === 0 && num === 0);
};

export const checkDomainFilter = (
  filterDomainIds: string[],
  domainNodes: DomainNode[] = [],
) =>
  filterDomainIds.some((domainId) =>
    domainNodes.some((domainNode) => {
      const isDirectDomain =
        !('type' in domainNode) || (domainNode as DomainNode).type === 'direct';
      if (!isDirectDomain) {
        return false;
      }

      const currentDomainId =
        (domainNode as { domain_id?: string; id?: string }).domain_id ??
        (domainNode as { domain_id?: string; id?: string }).id;

      return currentDomainId === domainId;
    }),
  );

const hasDirectScope = (domainNodes: DomainNode[] = []) =>
  domainNodes.some(({ type }) => type === 'direct');

const hasOperationalisedScope = (domainNodes: DomainNode[] = []) =>
  domainNodes.some(({ type }) => type === 'inherited');

const isNoOperationalisedNodeType = (type?: string) =>
  type === NodeDTOTypes.Service ||
  type === NodeDTOTypes.Capabilities ||
  type === NodeDTOTypes.Functions;

export const checkScopeFilter = (
  selectedFilters: string[],
  nodeType?: string,
  domainNodes: DomainNode[] = [],
) => {
  if (!selectedFilters.length) return true;

  const selectedDomainIds = extractDomainFilterIds(selectedFilters);

  const matchesSelectedDomains =
    selectedDomainIds.length > 0 &&
    checkDomainFilter(selectedDomainIds, domainNodes);

  const matchesUnassigned =
    selectedFilters.includes(SCOPE_FILTER_UNASSIGNED) &&
    !hasDirectScope(domainNodes);

  const matchesNoOperationalised =
    selectedFilters.includes(SCOPE_FILTER_NO_OPERATIONALISED) &&
    isNoOperationalisedNodeType(nodeType) &&
    hasDirectScope(domainNodes) &&
    !hasOperationalisedScope(domainNodes);

  return (
    matchesSelectedDomains || matchesUnassigned || matchesNoOperationalised
  );
};
